import React from "react"
import { useSelector } from "react-redux"
import styled from "styled-components"

import { StoreType } from "client/store"

export const NotAssignedSpan = styled.span`
    font-family: ${(props) => props.theme.openSans};
    font-size: ${(props) => props.theme.fontSizes.sm}px;
    color: grey !important;
`

export const NotAssigned = () => {
    const lang = useSelector((state: StoreType) => state.system.lang)
    return (
        <NotAssignedSpan>
            {lang.notAssigned}
        </NotAssignedSpan>
    )
}
